import { render } from "./AsBanner.vue?vue&type=template&id=31d79546&ts=true"
import script from "./AsBanner.vue?vue&type=script&lang=ts"
export * from "./AsBanner.vue?vue&type=script&lang=ts"

import "./AsBanner.vue?vue&type=style&index=0&id=31d79546&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__